// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"0c306945","453":"8b914fbf","576":"4c666241","606":"6aece09a","695":"dde8cf0d","717":"89490f10","864":"470905ef","901":"591ab8cf"}[chunkId] + ".chunk.js";
};